import { fansupportPublic } from "../index";

export const getTeamDetail = async ({ teamId }) => {
    return fansupportPublic.get('/sport/team-detail',{ params: { 
        teamId,
    }})
}